const ONE_SECOND = 1000;
export const ONE_MINUTE = ONE_SECOND * 60;